import { render } from "./Items.vue?vue&type=template&id=ada98b1a&scoped=true"
import script from "./Items.vue?vue&type=script&lang=js"
export * from "./Items.vue?vue&type=script&lang=js"

import "./Items.vue?vue&type=style&index=0&id=ada98b1a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ada98b1a"]])

export default __exports__